import { v4 as uuidv4 } from "uuid";
import {
    generateNewChoice,
    questionsDefault,
    generateDefaultPage,
    generateSurveyTemplate,
} from "../../surveys";

const pages = [
    {
        ...generateDefaultPage(),
        questions: [
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "Overall, how would you rate your purchase experience today?",
                choices: [
                    generateNewChoice("Excellent"),
                    generateNewChoice("Great"),
                    generateNewChoice("Good"),
                    generateNewChoice("Fair"),
                    generateNewChoice("Poor"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "The price was fair",
                choices: [
                    generateNewChoice("Strongly disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "The price was fair",
                choices: [
                    generateNewChoice("Strongly disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline:
                    "The information provided helped me make an informed decision",
                choices: [
                    generateNewChoice("Strongly disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "It was easy to understand the total cost",
                choices: [
                    generateNewChoice("Strongly disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["multipleChoiceSingle"],
                headline: "The terms of my purchase were clear",
                choices: [
                    generateNewChoice("Strongly disagree"),
                    generateNewChoice("Disagree"),
                    generateNewChoice("Neither agree nor disagree"),
                    generateNewChoice("Agree"),
                    generateNewChoice("Strongly Agree"),
                ],
            },
            {
                id: uuidv4(),
                ...questionsDefault["openText"],
                headline:
                    "What could we do to make the purchase process better?",
                longAnswer: true,
            },
        ],
    },
];

export const purchaseSatisfactionSurveyTemplate = generateSurveyTemplate({
    name: "Purchase Satisfaction Survey",
    pages,
});
